import React from 'react'
import { QuestionFrame, YesNoQuestion, TextFieldQuestion } from 'components/questions'


export const Q17 = () => {
  return (
    <QuestionFrame q={17}>
      <YesNoQuestion num={1} content={'雨水貯留施設（遊水地、雨水貯留槽等）を法定の基準を超えて設置していますか。'} />
      <YesNoQuestion num={2} content={'浸透桝（雨水貯留浸透槽を含む）、透水性アスファルト舗装や緑地エリアを法定の基準を超えて設置していますか。'} />
      <YesNoQuestion num={3} content={'地域住民や帰宅困難者等を対象とした災害時の避難施設を設置し、地域と協定等を締結していますか。'} />
      <YesNoQuestion num={4} content={'地域住民や帰宅困難者等を対象とした食料品等を備蓄し、地域と協定等を締結していますか。'} />
      <YesNoQuestion num={5} content={'災害時に地域の拠点（行政等の災害対策拠点）として使用する協定を結んでいますか。'} />
      <YesNoQuestion num={6} content={'災害予知システム（外水氾濫又は内水氾濫の発生に先立ち事前にリスクを通知するシステム）を構築・活用していますか。'} />
      <TextFieldQuestion num={7} content={'その他、先進的取組・地域貢献等はありますか。（自由記述）'} rows={4} />

    </QuestionFrame>
  )
}
